import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import showTpl from './showCoupon.html';
import useTpl from './useCoupon.html';
import showStyle from './showCouponStyle.less';
import useStyle from './useCouponStyle.less';
import { COUPON_STATUS } from '../../constants/index';
import componentUtils from '../../utils/index';

const { isFunction } = common;
const { getGiftEventName } = componentUtils;

const RedBag = (props = {}) => {
    const {
        redBagArrList,
        title,
        subtitle,
        size,
        useBtn,
        getBtn,
        isShowUse,
        onClickBtn,
        onClickReceiveAll,
    } = props;
    const data = {
        COUPON_STATUS,
        redBagArrList,
        title,
        subtitle,
        useBtn,
        getBtn,
    };
    const events = {
        onClickCouponBtn: async (poiIndex) => {
            const poiInfo = redBagArrList[poiIndex];
            if (isFunction(onClickBtn)) {
                await onClickBtn(poiInfo);
            }
        },
        onClickReceiveAllBtn: async () => {
            if (isFunction(onClickReceiveAll)) {
                await onClickReceiveAll(redBagArrList);
            }
        },
    };
    redBagArrList.forEach((poiInfo) => {
        const { gift_id: giftId } = poiInfo.giftInfo;
        const eventName = getGiftEventName(giftId);
        eventBus.$onceOn(eventName, (newStatus) => {
            const selector = `[data-gift-id=gift-id${giftId}]`;
            const btnDomList = Array.from(document.querySelectorAll(selector));
            if (btnDomList.length) {
                btnDomList.forEach((btnDom) => {
                    if (newStatus === COUPON_STATUS.STATUS_NEW) {
                        btnDom.innerText = getBtn;
                    } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
                        btnDom.innerText = useBtn;
                    }
                });
            }
        });
    });

    const styleName = isShowUse ? 'useCoupon' : 'showCoupon';
    const currentTpl = isShowUse ? useTpl : showTpl;
    const currentStyle = isShowUse ? useStyle : showStyle;
    currentStyle.currentSize = currentStyle[`${styleName}_${size}`];

    const component = createComponent(currentTpl, { data, style: currentStyle }, events);
    return component;
};

export default RedBag;
